/* eslint-disable @typescript-eslint/no-explicit-any */
import CryptoJS from 'crypto-js';
import { fileTypeFromBuffer } from 'file-type';

type FileType = {
    code: string;
    extensions: Array<string>
  }

export const sanitizeFile = async (file: any, fileTypes: Array<FileType>) => {
  const rawFile: File = file.rawFile;
  const extension: string = file.name.slice((file.name.lastIndexOf('.') - 1 >>> 0) + 2);
  const buffer = await rawFile.arrayBuffer();
  const hash: string = await CryptoJS.MD5(CryptoJS.lib.WordArray.create(buffer)).toString();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  let type: any = await fileTypeFromBuffer(buffer);

  if (
    type === undefined ||
    (
      type.mime === 'application/xml' && extension.toLowerCase() === 'svg'
    )
  ) {
    const fileType = fileTypes.find(fileType => fileType.extensions.includes(`.${extension}`));

    type = {
      ext: extension,
      mime: fileType.code
    };
  }

  const sanitizedName: string = await encodeURIComponent(rawFile.name);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const sanitizedFile: any = new File([rawFile], sanitizedName, { type: type.mime });
  file.name = sanitizedName;
  file.mime = type.mime;
  file.hash = hash;
  file.rawFile = sanitizedFile;
};